// client/src/components/TiptapEditor/TiptapEditor.js

import React, { useEffect } from "react"; // 1. IMPORTAMOS useEffect
import { useEditor, EditorContent } from "@tiptap/react";

// Extensiones Principales
import StarterKit from "@tiptap/starter-kit";
import { Color } from "@tiptap/extension-color";
import TextStyle from "@tiptap/extension-text-style";
import FontFamily from "@tiptap/extension-font-family";
import Highlight from "@tiptap/extension-highlight";
import Image from "@tiptap/extension-image";
import Link from "@tiptap/extension-link";
import Placeholder from "@tiptap/extension-placeholder";
import Table from "@tiptap/extension-table";
import TableCell from "@tiptap/extension-table-cell";
import TableHeader from "@tiptap/extension-table-header";
import TableRow from "@tiptap/extension-table-row";
import TextAlign from "@tiptap/extension-text-align";
import Underline from "@tiptap/extension-underline";
import { FontSize } from "./extensions/FontSize";

// Componentes de la UI
import { MenuBar } from "./MenuBar";
import "./TiptapEditor.scss";

// Función de ayuda para configurar extensiones de forma segura
const cfg = (Ext, opts = {}) =>
  typeof Ext?.configure === "function" ? Ext.configure(opts) : Ext;

// 2. EL COMPONENTE AHORA ACEPTA PROPS: 'content' y 'onChange'
export const TiptapEditor = ({ content, onChange }) => {
  const editor = useEditor({
    extensions: [
      cfg(StarterKit, {
        table: false,
        heading: {
          levels: [1, 2, 3],
          marks: true,
        },
      }),
      // Marcas y Estilos
      Underline,
      Highlight,
      TextStyle,
      Color,
      FontFamily,
      FontSize,
      // Nodos de Bloque
      Image,
      cfg(Table, { resizable: true }),
      TableRow,
      TableHeader,
      TableCell,
      // Otras funcionalidades
      cfg(Link, { openOnClick: true, autolink: true }),
      cfg(TextAlign, { types: ["heading", "paragraph"] }),
      cfg(Placeholder, { placeholder: "Empieza a escribir aquí…" }),
    ],
    // 3. EL CONTENIDO INICIAL VIENE DE LAS PROPS
    content: content,

    // 4. CADA VEZ QUE EL EDITOR SE ACTUALIZA...
    onUpdate: ({ editor: ed }) => {
      // ...LLAMAMOS A LA FUNCIÓN onChange QUE NOS PASÓ EL FORMULARIO
      onChange(ed.getHTML());
    },
  });

  // 5. EFECTO PARA SINCRONIZAR CUANDO EL CONTENIDO CAMBIA DESDE FUERA (FORMIK)
  useEffect(() => {
    if (editor && content && editor.getHTML() !== content) {
      editor.commands.setContent(content, false);
    }
  }, [content, editor]);

  if (!editor) {
    return null;
  }

  return (
    <div className="tiptap-editor-container">
      <MenuBar editor={editor} />
      <EditorContent editor={editor} />
    </div>
  );
};
